import { createSelector } from 'reselect';
import { get } from 'lodash/fp';

import chatChannelsSelector from './chatChannelsSelector';

function getChatPath(chatURI, channels, currentChannelId, token) {
  if (!chatURI) {
    return undefined;
  }

  const channel = channels.find(c => c.id === currentChannelId);
  if (!channel) {
    return undefined;
  }

  const basePath = `${chatURI}/channel/${channel.slug}`;
  return token ? `${basePath}?jwt=${token}` : basePath;
}

const chatPathSelector = createSelector(
  get('settings.chatURI'),
  state => chatChannelsSelector(state),
  state => state.chat.channelId,
  get('user.token'),
  getChatPath
);

export default chatPathSelector;
